<template>
  <div class="package">
    <div class="page-intro page-intro--packages">
      <b-container>
        <b-row>
          <b-col lg="4" offset-lg="1">
            <h1 class="page-intro__title" v-t="'package'"></h1>
            <div class="package-options">
              <div class="package-options__selected" v-on:click="toggleOptions">{{name}}</div>
              <div class="package-options__list">
                <router-link v-for="p in packages" v-bind:key="p.id" v-bind:to="p.id" class="package-options__item">{{p.name}}</router-link>
              </div>
            </div>
          </b-col>
          <b-col lg="5" offset-lg="2">
            <div class="package-info">
              <div class="package-info__features">
                <div class="package-info__block package-info__block--highlighted">
                  <i class="icon-bed package-info__icon"></i>
                  <div class="package-info__info">
                    <strong class="package-info__highlight">{{ $t('packageBenefits.accommodation.title') }}</strong>: {{ $t('packageBenefits.accommodation.description') }}
                  </div>
                </div>
                <div class="package-info__block">
                  <i class="icon-photos package-info__icon"></i>
                  <div class="package-info__info">
                    <strong class="package-info__highlight">{{ $t('packageBenefits.experiences.title') }}</strong>: {{ $t('packageBenefits.experiences.description') }}
                  </div>
                </div>
                <div class="package-info__block">
                  <i class="icon-cards package-info__icon"></i>
                  <div class="package-info__info">
                    <strong class="package-info__highlight">{{ $t('packageBenefits.cards.title') }}</strong>: {{ $t('packageBenefits.cards.description') }}
                  </div>
                </div>
              </div>
              <div class="package-info__pricing">
                <div class="package-info__price">{{price}}€</div>
                <span class="package-info__note" v-t="'disclaimer'"></span>
              </div>
            </div>
          </b-col>
        </b-row>
        <div class="page-intro__cta">Veja em detalhe as ofertas</div>
        <a href="#ofertas" class="page-intro__skip"><span class="sr-only">Saltar para as ofertas</span></a>
      </b-container>
    </div>
    
    <b-container class="my-5">
      <h1 v-t="'reserveNow'"></h1>
      <b-row align-h="center" class="mt-4">
        <b-col lg="2" md="12" class="mb-4">
          <b-button variant="primary" class="btn--phone" href="tel:210312807">210 312 807</b-button>
        </b-col>
        <b-col lg="2" md="12" class="mb-4">
          <b-button variant="primary" class="btn--phone" href="tel:919878409">919 878 409</b-button>
        </b-col>
        <b-col lg="2" md="12" class="mb-4">
          <b-button variant="primary" class="btn--email" href="mailto:info@lismarketing.pt">info@lismarketing.pt</b-button>
        </b-col>
      </b-row>
      <p class="reservation-note" v-html="$t('offers.disclaimer')"></p>
    </b-container>
    
    <b-container id="ofertas">
      <h2 v-html="$t('offers.addons')"></h2>

      <b-tabs class="mt-5">
        <b-tab title="Hotéis" active>
          <h3 class="page-heading">Hotéis disponíveis neste pacote</h3>
          <b-row>
            <b-col cols="12" md="6" lg="4" v-for="data in options.hotels" v-bind:key="data.id" class="mb-4">
              <Hotel v-bind:image="data.image" v-bind:name="data.name" v-bind:description="data.description" v-bind:address="data.address" v-bind:rating="data.rating" />
            </b-col>
          </b-row>
        </b-tab>
        <b-tab :title="$t('experiences')">
          <h3 class="page-heading">Experiências disponíveis neste pacote</h3>

          <b-row>
            <b-col cols="12" md="6" lg="4" v-for="data in options.experiences" v-bind:key="data.id" class="mb-4">
              <Experience v-bind:image="data.image" v-bind:name="data.name" v-bind:description="data.description" v-bind:companies="data.companies" v-bind:routing="data.routing" />
            </b-col>
          </b-row>
        </b-tab>
        <b-tab title="Lisboa Card">
          <h3 class="page-heading" v-t="'lisboaCard.title'"></h3>

          <b-row>
            <b-col cols="12" md="6" lg="4" v-for="data in options.card" v-bind:key="data.id" class="mb-4">
              <Experience v-bind:image="data.image" v-bind:name="data.name" v-bind:description="data.description" />
            </b-col>
          </b-row>

          <h3 class="page-heading mt-5" v-t="'lisboaCard.attractions'"></h3>
          <b-button variant="outline-primary" href="https://www.visitlisboa.com/en/shop/lisbon-card" target="_blank">Veja aqui quais são</b-button>
        </b-tab>
      </b-tabs>
    </b-container>

    <b-container id="incentivos" class="mt-5 mb-5">
      <h3 class="page-heading">Ofertas Complementares</h3>

      <b-row class="mb-3">
        <b-col cols="12" lg="9" class="mx-auto">
          <i18n path="discounts.longDescription" tag="h2">
              <router-link to="/pacotes/base">Base</router-link>
              <router-link to="/pacotes/plus">Plus</router-link>
              <router-link to="/pacotes/premium">Premium</router-link>
          </i18n>
        </b-col>
      </b-row>

      <b-tabs>
        <b-tab :title="$t('discounts.items.restaurants')" active>
          <b-row>
            <b-col cols="12" md="6" lg="4" v-for="data in options.restaurants" v-bind:key="data.id" class="mb-4">
              <Experience v-bind:image="data.image" v-bind:meta="data.meta" v-bind:name="data.name" v-bind:description="data.description" v-bind:address="data.address" v-bind:contact="data.contact" />
            </b-col>
          </b-row>
        </b-tab>
        <b-tab :title="$t('discounts.items.counties')">
          <b-row>
            <b-col cols="12" lg="6" v-for="data in options.institutional" v-bind:key="data.id" class="mb-4">
              <Experience v-bind:image="data.image" v-bind:meta="data.meta" v-bind:name="data.name" v-bind:description="data.description" v-bind:address="data.address" v-bind:contact="data.contact" v-bind:blocks="data.blocks" />
            </b-col>
          </b-row>
        </b-tab>
        <b-tab :title="$t('discounts.items.tours')">
          <b-row>
            <b-col cols="12" md="6" lg="4" v-for="data in options.tours" v-bind:key="data.id" class="mb-4">
              <Experience v-bind:image="data.image" v-bind:meta="data.meta" v-bind:name="data.name" v-bind:description="data.description" v-bind:address="data.address" v-bind:contact="data.contact" v-bind:blocks="data.blocks" />
            </b-col>
          </b-row>
        </b-tab>
        <b-tab :title="$t('discounts.items.cellars')">
          <b-row>
            <b-col cols="12" md="6" lg="4" v-for="data in options.vineyards" v-bind:key="data.id" class="mb-4">
              <Experience v-bind:image="data.image" v-bind:meta="data.meta" v-bind:name="data.name" v-bind:description="data.description" v-bind:address="data.address" v-bind:contact="data.contact" v-bind:blocks="data.blocks" />
            </b-col>
          </b-row>
        </b-tab>
        <b-tab :title="$t('discounts.items.other')">
          <b-row>
            <b-col cols="12" md="6" lg="4" v-for="data in options.other" v-bind:key="data.id" class="mb-4">
              <Experience v-bind:image="data.image" v-bind:meta="data.meta" v-bind:name="data.name" v-bind:description="data.description" v-bind:address="data.address" v-bind:contact="data.contact" v-bind:blocks="data.blocks" />
            </b-col>
          </b-row>
        </b-tab>
      </b-tabs>
    </b-container>

    <Footer />
  </div>
</template>

<script>
  import { BTabs, BTab } from 'bootstrap-vue';
  import Experience from '@/components/Experience.vue'
  import Hotel from '@/components/Hotel.vue'
  import Experiences from '@/data/experiences.json'
  import Hotels from '@/data/hotels.json'
  import Restaurants from '@/data/restaurants.json'
  import Tourism from '@/data/tourism.json'
  import Institutional from '@/data/institutional.json'
  import Footer from '@/components/Footer.vue'

  export default {
    name: 'Packages',
    props: {
      id: String,
      name: String,
      price: Number
    },
    data() {
      return { 
        options: {
          hotels: Hotels.filter((hotel) => hotel.package === this.id).sort((hotel, compare) => hotel.name > compare.name),
          experiences: Experiences.filter((experience) => experience.package),
          card: [
            { id: 1, name: 'Transportes Gratuitos', description: 'Circulação grátis de metro e nos autocarros, eléctricos, elevadores da Carris. Linha de Sintra - Rossio, Linha de Cascais - Cais do Sodré, Linha Azambuja, Fertagus - Setúbal' },
            { id: 2, name: 'Entrada Gratuita em Museus', description: 'Entrada gratuita em 35 museus, monumentos e outros locais de interesse.' },
            { id: 3, name: 'Descontos', description: '10% a 50% de desconto em locais e serviços de interesse turístico e cultural. 5% a 10% de desconto em algumas lojas de artigos genuinamente portugueses.' }
          ],
          restaurants: Restaurants.sort((restaurant, compare) => restaurant.name > compare.name),
          tours: Tourism.filter((entity) => entity.type === 'tours'),
          vineyards: Tourism.filter((entity) => entity.type === 'vineyards').sort((entity, compare) => entity.name > compare.name),
          other: Tourism.filter((entity) => entity.type === 'other').sort((entity, compare) => entity.name > compare.name),
          institutional: Institutional.sort((entity, compare) => entity.name > compare.name),
        }
      }
    },
    computed: {
      packages: function() {
        const options = [
          { id: 'base', name: 'Base' },
          { id: 'plus', name: 'Plus' },
          { id: 'premium', name: 'Premium' }
        ]
        return options.filter((option) => option.id !== this.id)
      }
    },
    components: {
      BTabs,
      BTab,
      Experience,
      Hotel,
      Footer
    },
    methods: {
      toggleOptions(event) {
        const target = event.currentTarget.closest('.package-options')
        target.classList.toggle('package-options--expanded')
      }
    }
  }
</script>

<style lang="scss" scoped>
  .reservation-note {
    color: rgba(17, 25, 28, .5);
  }
</style>